/** Component `name` values matched by WorkspaceShell `<keep-alive include>`. */
export const SHELL_KEEP_ALIVE_NAMES = [
  'NotificationsView',
  'DashboardView',
  'PlanCoverageView',
  'TableView',
  'DepartmentsView',
  'PositionsView',
  'InboxView',
  'EmployeeDetailView',
  'AllWorkflowsView',
  'EmployeeReportsView',
  'TreeView',
  'AttendanceView',
  'DirectoryView',
  'PastEmployeesView',
  'PayrollReportsView',
  'CalendarView',
  'CandidatesView',
  'CompensationView',
  // ModulePlaceholderView intentionally omitted — one component serves many routes.
];

/** LRU cap for WorkspaceShell keep-alive (lower = less RAM on weak devices). */
export const SHELL_KEEP_ALIVE_MAX = 6;

const PARAM_ROUTE_NAMES = new Set([
  'employee-detail',
  'employee-edit',
  'plan-editor',
  'appraisal-editor',
  'employee-reports'
]);

/**
 * keep-alive cache key: unique per route; fullPath for param editor routes.
 * employee-detail excludes query (?tab=) — tabs sync via replace on mount and must
 * not remount the page mid WorkspaceShell Transition (empty outlet).
 */
export function shellViewCacheKey(route) {
  const name = route?.name;
  if (name && PARAM_ROUTE_NAMES.has(String(name))) {
    if (String(name) === 'employee-detail' || String(name) === 'employee-edit') {
      return `${String(name)}:${route.params?.id ?? ''}`;
    }
    return route.fullPath;
  }
  return name ? String(name) : route?.path || '/';
}

/**
 * Lazy import helper: keep-alive matches resolved SFC by `name`.
 * Some build paths omit `name` on the async boundary — set it explicitly.
 */
export function lazyRouteView(importFn, cacheName) {
  return () =>
    importFn().then((mod) => {
      if (mod?.default && cacheName) {
        Object.defineProperty(mod.default, 'name', {
          value: cacheName,
          configurable: true
        });
      }
      return mod;
    });
}
